import { SEARCH_STATE } from './constants'
import { DEFAULT_SEARCH } from 'src/constants/search'
import { sanitizeSearchParams } from 'client/utils'

const state = {
  [SEARCH_STATE]: sanitizeSearchParams({
    adults: DEFAULT_SEARCH.adults,
    checkIn: DEFAULT_SEARCH.checkIn,
    checkOut: DEFAULT_SEARCH.checkOut,
    children: DEFAULT_SEARCH.children,
    city: '',
    country: '',
    latitude: '',
    longitude: '',
    market: '',
    slug: '',
    term: '',
    type: '',
  }),
  lastSuggestion: {},
}

export default state
